import React from "react";
import { useSelector, useDispatch } from 'react-redux';

import { Col, Row } from "antd";

import AccountBreadcrumb from "../../../../commons/components/AccountBreadcrumb";

import { accessManagementSetShowPartners, accessManagementSetShowUsers, accessManagementSetSearchPartner } from "../../../../store/actions/accessManagementActions";
import {
    Title
} from './cardHeaderStyles';

import ButtonBack from "../../../../commons/components/buttonBack";

function CardHeader(props) {
    const dispatch = useDispatch();
    const { selectedPartner } = useSelector((state) => state.accessManagement);

    function handleBack() {
        dispatch(accessManagementSetShowPartners(true));
        dispatch(accessManagementSetShowUsers(false));
        dispatch(accessManagementSetSearchPartner());
    }

    return (
        <Row>
            <Col>
                <div style={{ display: "flex", alignItems: "center" }}>
                        <ButtonBack style={{margin: 0}} className={"complete-data-button-back"} onClick={() => handleBack()} />
                    <div>
                        <Title className={"dados-header"}>{selectedPartner.trading_name}</Title>
                        <AccountBreadcrumb company_name={selectedPartner.trading_name} />
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default CardHeader;
